module.exports = __webpack_public_path__ + "static/media/tm6_9.7d974593.svg";